import { useTranslations } from '@lang';
import { useNavigationLabels } from './queries';
import { getLanguageCodeFromLocale } from '@utils/getLanguageCodeFromLocale';

export function useLabels() {
  const { locale } = useTranslations();
  const { data } = useNavigationLabels();
  const raw = data?.[getLanguageCodeFromLocale(locale)] || {};

  const navigationLabels: { [key: string]: string } = {};
  Object.entries(raw).forEach(([key, value]) => {
    if (value) navigationLabels[key] = value;
  });

  return navigationLabels;
}
